import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { BulletList } from "./components/BulletList";

const styles = StyleSheet.create({
  container: {
    width: "100%",
    display: "flex",
    marginBottom: 12
  },
  title: {
    fontWeight: 700
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%"
  }
});

export const Education = ({ education }) => {
  const { qualification, institution, started, finished } = education;

  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View>
          <Text style={styles.title}>
            {qualification}, {institution}
          </Text>
        </View>

        <View>
          <Text style={styles.started}>
            {started} ⁠— {finished}
          </Text>
        </View>
      </View>
    </View>
  );
};
